import { Action } from '@ngrx/store';
import {StatusParams, StatusPeakLog} from "../status.model";

export enum StatusAggregationActionTypes {
  LoadStatusAggregations = '[StatusAggregation] Load StatusAggregations',
  GetStatusAggregations = '[StatusAggregation] GetStatusAggregations',
  GetStatusAggregationsFail = '[StatusAggregation] GetStatusAggregationsFail',
}

export class LoadStatusAggregations implements Action {
  readonly type = StatusAggregationActionTypes.LoadStatusAggregations;
  constructor(public payload: StatusPeakLog[]) {}
}

export class GetStatusAggregations implements Action {
  readonly type = StatusAggregationActionTypes.GetStatusAggregations;
  constructor(public payload: StatusParams) {}
}

export class GetStatusAggregationsFail implements Action {
  readonly type = StatusAggregationActionTypes.GetStatusAggregationsFail;
}


export type StatusAggregationActions = LoadStatusAggregations
  | GetStatusAggregations
  | GetStatusAggregationsFail;
